/** Tiền tố URL của trang danh sách quán. */
export const LISTING_PREFIX = 'danh-sach-cua-hang';

/**
 * Segment này là URL danh sách quán (bản rootless) chứ không phải tên city?
 *
 * Danh sách quán nhét cả bộ lọc vào chính segment
 * (`danh-sach-cua-hang-tra-sua-co-freeship`) nên không thể khớp bằng thư mục
 * tĩnh — phải nhận bằng tiền tố. Điều kiện ngầm: KHÔNG được có city nào slug bắt
 * đầu bằng `danh-sach-cua-hang`.
 *
 * BẮT BUỘC dùng ở mọi nơi đọc `params.city`: URL rootless
 * `/danh-sach-cua-hang-co-freeship` được phục vụ bởi route `[city]`, nên
 * `useParams().city` trả về chính segment listing chứ không phải `undefined`.
 * Bỏ qua bước lọc này thì code sẽ tưởng user đang duyệt một city tên là
 * "danh-sach-cua-hang-co-freeship" — link sinh ra thành
 * `/danh-sach-cua-hang-co-freeship/solomeal`, và mọi so sánh với city của địa
 * chỉ đều sai.
 */
export function isListingSegment(segment: string): boolean {
  return segment === LISTING_PREFIX || segment.startsWith(`${LISTING_PREFIX}-`);
}
